import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import Layout from "../../../components/layout";
import ReporteGeneralVendedorComponent from "../../../components/comisionesAnualidad/reporteGeneralVendedor/ReporteGeneralVendedor";
import {
  ReporteGeneralVendedorStore,
  reporteGeneralVendedorStore
} from "./ReporteGeneralVendedor.store";
import {
  ReporteGeneralVendedorDispatcher,
  reporteGeneralVendedorDispatcher
} from "./ReporteGeneralVendedor.dispatcher";

interface Props
  extends ReporteGeneralVendedorStore,
    ReporteGeneralVendedorDispatcher {}

/**
 * REPORTE GENERAL DE VENDEDORES — Container Redux
 * ---------------------------------------------------------------------------
 * Pantalla: /reportes/reporte-general-vendedor
 *
 * - Conecta con Redux vía ReduxConnect (meta.resolver + await Preview).
 * - Título breadcrumb: "Reporte General Vendedores" (headerLabel).
 * - Expone al presentational: snapshot, loading/error y actions
 *   clearAnualidadSnapshot / getReporteGeneralVendedor.
 * - BFF: GET /api/comisiones-anualidad/snapshot/reporte-general-vendedor
 *   → MS: GET /v1/anualidad-snapshot/reporte-general-vendedor
 */
@Router()
@ReduxConnect(reporteGeneralVendedorStore, reporteGeneralVendedorDispatcher)
export default class ReporteGeneralVendedorContainer extends Component<Props> {
  render() {
    return (
      <main>
        <Helmet title="Reporte General Vendedores" />
        <Layout headerLabel="Reporte General Vendedores">
          <ReporteGeneralVendedorComponent
            userContext={this.props.userContext}
            snapshot={this.props.snapshot}
            gettingSnapshot={this.props.gettingSnapshot}
            gettingSnapshotError={this.props.gettingSnapshotError}
            clearAnualidadSnapshot={this.props.clearAnualidadSnapshot}
            getReporteGeneralVendedor={this.props.getReporteGeneralVendedor}
          />
        </Layout>
      </main>
    );
  }
}
